import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PRICE } from '../../data/content';
import { CtaButton } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-178" data-mp="201uv57pkk1yf">
      {visible && <motion.div initial={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} animate={reduceMotion ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-ink-border bg-ink-950/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-179" data-mp="2etd5opznt4ae">
          <div className="flex items-center gap-3" data-id="element-180" data-mp="13rug2own6h6g">
            <div className="shrink-0" data-id="element-181" data-mp="13t5hwj6j1eux">
              <p className="text-[11px] font-semibold text-subtle" data-id="element-182" data-mp="17rmkqqix036j">Pack completo</p>
              <p className="font-display text-xl font-black leading-none text-white" data-id="element-183" data-mp="1cqxzxv3mv0m0">{PRICE}</p>
            </div>
            <div className="flex-1" data-id="element-184" data-mp="1hqu35s4iao0i">
              <CtaButton size="sm" fullWidth data-id="element-185" data-mp="1hrvjab0dq0p3" />
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}